export default __webpack_public_path__ + "static/fans-hero-light-84343927d0302804a531c9f179d620d3.png";